"use client";
import React, { useState } from "react";
import axios from "axios";
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function IntegrationsPage() {
  const [showPrevScreen, setShowPrevScreen] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    protocol: "http(s)",
    url: "",
    headers: [{ key: "", value: "" }],
  });
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [question, setQuestion] = useState("");
  const [integrationDetails, setIntegrationDetails] = useState([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleHeaderChange = (index, event) => {
    const { name, value } = event.target;
    const newHeaders = [...formData.headers];

    newHeaders[index][name] = value;
    setFormData({ ...formData, headers: newHeaders });

    if (name === "key" && value.length === 1 && index === newHeaders.length - 1) {
      setFormData({
        ...formData,
        headers: [...newHeaders, { key: "", value: "" }],
      });
    }

    if (name === "key" && value.length === 0 && index === newHeaders.length - 2) {
      setFormData({
        ...formData,
        headers: newHeaders.slice(0, -1),
      });
    }
  };

  const handleShowOptions = async () => {
    setIntegrationDetails([]);
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `https://cqube.sstus.net/get_answer`,
        { question, type: "integration" },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );
      if (response.status === 200) {
        setIntegrationDetails(response.data.Integration_details || []);
      } else {
        throw new Error("Failed to fetch options");
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.status === 403) {
        localStorage.removeItem("token");
        localStorage.removeItem("isLoggedIn");
        setError("Session expired. Please login again.");
        navigate("/login", { state: { from: "/EcommerceBot" } });
      } else {
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    // <>Akshay</>
    <Container className="d-flex min-vh-100 justify-content-center align-items-center" style={{ backgroundColor: "#1A1A1A" }}>
      <Card className="p-4 w-100" style={{ maxWidth: "700px", backgroundColor: "#1c1c1e", color: "white" }}>
        {showPrevScreen ? (
          <>
            <h1 className="text-center">Create Integration</h1>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>What system you're integrating with?</Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      type="text"
                      placeholder="Example: Kibo OMS"
                      value={question}
                      onChange={(e) => setQuestion(e.target.value)}
                    />
                  </Col>
                  <Col xs="auto">
                    <Button variant="info" onClick={handleShowOptions}>
                      Show options
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
              {loading && <Spinner animation="border" variant="light" />}
              {error && <Alert variant="danger">Error: {error}</Alert>}
              <Row className="g-3">
                {integrationDetails.length > 0 ? (
                  integrationDetails.map((integration, index) => (
                    <Col key={index} md={6}>
                      <Card className="p-3" bg="dark" text="light" onClick={() => {
                        setFormData({
                          name: integration.name,
                          url: integration.https.url,
                          headers: integration.https.headers
                            ? Object.entries(integration.https.headers).map(
                                ([key, value]) => ({ key, value })
                              )
                            : [{ key: "", value: "" }],
                          protocol: "http(s)",
                        });
                        setShowPrevScreen(false);
                      }}>
                        <Card.Title>{integration.name}</Card.Title>
                        <Card.Text>
                          <strong>URL:</strong>{" "}
                          <a href={integration.https.url} className="text-info" target="_blank" rel="noopener noreferrer">
                            {integration.https.url}
                          </a>
                        </Card.Text>
                      </Card>
                    </Col>
                  ))
                ) : (
                  !loading && <p className="text-muted">No integration options available</p>
                )}
              </Row>
            </Form>
          </>
        ) : (
          <>
            <h1 className="text-center text-info">Create Integration</h1>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Integration name"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Protocol *</Form.Label>
                <Form.Control
                  type="text"
                  name="protocol"
                  value={formData.protocol}
                  onChange={handleChange}
                  placeholder="http(s)"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>URL *</Form.Label>
                <Form.Control
                  type="url"
                  name="url"
                  value={formData.url}
                  onChange={handleChange}
                  placeholder="https://"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Headers</Form.Label>
                {formData.headers.map((header, index) => (
                  <Row key={index} className="mb-2">
                    <Col>
                      <Form.Control
                        type="text"
                        name="key"
                        value={header.key}
                        onChange={(e) => handleHeaderChange(index, e)}
                        placeholder="Key"
                      />
                    </Col>
                    <Col>
                      <Form.Control
                        type="text"
                        name="value"
                        value={header.value}
                        onChange={(e) => handleHeaderChange(index, e)}
                        placeholder="Value"
                      />
                    </Col>
                  </Row>
                ))}
              </Form.Group>

              <Row className="mt-4">
                <Col>
                  <Button variant="outline-info" onClick={() => setShowPrevScreen(true)}>
                    Back
                  </Button>
                </Col>
                <Col className="text-end">
                  <Button variant="primary">Save Integration</Button>
                </Col>
              </Row>
            </Form>
          </>
        )}
      </Card>
    </Container>
  );
};
 